import { useQuery } from "react-query";

import { adminApis, queryKeys } from "./index";

export const useGetLastDraw = () => {
  return useQuery([queryKeys.JACKPOT_LAST_DRAW], adminApis.getLastDraw, {
    keepPreviousData: true,
  });
};
